<template>
  <div>
    <h1>TERMS OF USE</h1>
    <h4>PLEASE READ THESE TERMS OF USE CAREFULLY BEFORE USING OUR SERVICES</h4>
    <p>
      <b>
        You hereby confirm that you have read and understood these Terms of Use and consent to them. Any use of the
        service or related services constitutes acceptance of these Terms of Use.
      </b>
    </p>
    <div class="text-left">
      <h4>1. CONTRACTUAL RELATIONSHIP</h4>
      <p>
        1.1 These terms and conditions (‘Terms of Use’) represent the contractual basis between you and Smartdine
        Sàrl, a
        limited liability company with offices in Versoix (Geneva) in Switzerland. Smartdine Sàrl is registered in the
        commercial registry under company number CHE-255.736.040 (‘Smartdine’). The Terms of Use apply to your visit to
        and
        use of our website
        <a
          href="https://www.smartdine.ch"
        >www.smartdine.ch</a> (the ‘Website’) and to the Service
        and
        all information, recommendations and services provided to you through the Website.
      </p>
      <p>
        1.2 Through use of the Service and related services, you consent to enter into this contract (the ‘Contract’)
        with
        Smartdine.
      </p>
      <p>
        1.3 At its own discretion and without liability, Smartdine can terminate these Terms of Use or the Contract and
        all
        services at any time and with immediate effect, either fully or in part, modify, adjust, limit, discontinue or
        suspend the Service, and all services at any time, either fully or in part (including the availability of any
        data,
        databases or content) or refuse access to the Service or all services at any time, either fully or in part, for
        any
        reason, and block or delete the related data, in particular your user account, either fully or in part. However,
        Smartdine will announce such measures through a notification on the Website or to you. Additionally, Smartdine
        can
        ask you to acknowledge an emended version of these Terms of Use immediately by clicking. Your continued use of
        the
        Service or Platform after Smartdine has notified you of the changes constitutes acceptance of the modifications,
        As
        the services provided by Smartdine are standardized, we cannot consider any changes to processes that you might
        suggest. If you propose amendments to the Terms of Use, these amendments will under no circumstances become
        valid
        unless we duly acknowledge them in writing in advance.
      </p>
      <p>
        1.4 Personal data will be collected and processed in connection with the Service in line with
        <span
          style="color: red;"
        >our privacy policy</span> at
        <a href="https://www.smartdine.ch">www.smartdine.ch</a>.
        <span style="font-weight: bold;">
          By consenting to these Terms of Use, you also recognize and accept our privacy
          policy.
        </span>
      </p>

      <h4>2. THE SERVICES</h4>
      <p>
        2.1 The Smartdine web-app based platform (the ‘Platform’), which can be accessed from any web- browser, allows
        you
        to scan QR codes, place orders for food and drink and pay in certain independent restaurants (‘Participating
        Restaurants’).
      </p>
      <p>
        2.2 On the Platform, you can browse and order food and drinks in a Participating Restaurant. Your order
        triggers a
        process in the Participating Restaurant that provides it with information, including your personal data, your
        order
        with the appropriate table number. Your table number is determined when you scan the QR code on the
        Participating
        Restaurant’s table.
      </p>
      <p>
        2.3 Smartdine passes your order on to the Participating Restaurant and settles it in the name and for the
        account
        of the Participating restaurant. All brokering and billing services rendered for you by Smartdine, as well as
        the
        platform, are hereinafter referred to as the ‘Service’. The Service is for private, non-commercial use only.
      </p>
      <p>
        2.4
        <span style="font-weight: bold;">
          The Participating Restaurants render their catering services in their own
          name
          and on their own account. The Participating Restaurants in no way act for Smartdine. You therefore enter into
          a
          contract with the Participating Restaurant, rather than Smartdine.
        </span>
      </p>
      <p>2.5 Smartdine itself does not provide any food or drink or run any restaurants.</p>
      <p>
        2.6 Furthermore, it is solely at the discretion of the Participating Restaurant to enter into a service
        contract or any other contract with you.
      </p>
      <p>
        2.7 You are not obliged to use the Service; similarly, Smartdine is not obliged to offer you the Service
        or to render the Service successfully (in particular, to pass on orders or process payments).
      </p>
      <p>
        2.8 Smartdine serves as a platform that represents the services of the restaurant and enables you to
        place an order and make payment directly from your smartphone. The catering services (including orders and
        payments)
        are therefore subject to an agreement between you and the Participating Restaurant is not part of these Terms of
        Use; the provisions agreed between you and the Participating Restaurant apply, each participating Restaurant is
        responsible for such provisions.
        <span
          style="font-weight: bold;"
        >
          At no time is Smartdine party to such an
          agreement.
        </span>
      </p>

      <h4>3. USER OF THE SERVICE</h4>
      <p>
        3.1 You must be
        <span style="font-weight: bold;">at least 18 years of age</span> to use the Service. You
        confirm
        that you are a legally
        capable individual who is able to enter into a binding contract.
      </p>3.2 In particular, you undertake the following:
      <ul>
        <li>You will use the Service only for private, non-commercial purposes and not pass it on to third parties</li>
        <li>
          You will comply with all relevant legislation when using the Service, and you will use the Service only
          for
          legal purposes
        </li>
        <li>You will not use the Service to cause annoyance, disruption or inconvenience</li>
        <li>You will not impede the correct operation of the network</li>
        <li>You will not attempt to harm the Service in any way</li>
        <li>You will provide us with any proof of your identity that we consider reasonable</li>
        <li>You will not use the Service with an incompatible or unauthorized device</li>
      </ul>

      <p>
        3.3 In particular, Smartdine reserves the right to terminate the Service and use of the Service immediately if
        you
        do not fulfil all of the above obligations.
      </p>
      <p>
        3.4 You are responsible for the establishment and functioning of the data network access required for use of
        the
        Service, and for any related costs. Access to and/or use of the Service may incur data and connection fees from
        your
        mobile network provider; for example, payment for which you are solely responsible.
      </p>
      <p>
        3.5 You are responsible for procurement and update of the compatible hardware and devices required to access
        and
        use the Service. Smartdine does not guarantee that the Service or parts thereof will work on the hardware or
        devices
        in question. Additionally, the Service may experience problems and delays caused by use of the internet and
        electronic means of communication.
      </p>
      <p>
        3.6 In particular, Smartdine cannot be held liable if you have no functional data network access or compatible
        mobile device.
      </p>

      <h4>4. PAYMENT</h4>
      <p>
        4.1 The Service can be used free of charge. Smartdine reserves the right to introduce a fee for use of the
        Service.
        If Smartdine decides to introduce a fee, it will notify you in advance and give you the opportunity to terminate
        the
        Contract.
      </p>

      <p>
        4.2
        <span style="font-weight: bold;">
          You are aware that use of the offers of the Participating Services through
          the
          Service will incur costs.
        </span>
      </p>
      <p>
        4.3 The prices of the menu items offered by Participating Restaurants (e.g. food and drink) can be found on the
        Platform. These prices are set by the restaurant in question and are changed/updated from time to time. It is
        your
        responsibility to check the current prices of the menu items of the restaurant in question.
      </p>
      <p>
        4.4 Smartdine will charge the prices of the food and drink, other menu items or services you order from the
        Participating Restaurant using the Service in the name of the restaurant. Smartdine will clear your payment with
        the
        Participating Restaurant by acting with the limited authorization of the restaurant to collect payments. The
        payments you make in this way are thus treated as if you had made them to the Participating Restaurant directly.
        All
        prices are payable immediately.
      </p>
      <p>
        4.5 You agree to pay for all food, drink and other goods you order from a Participating Restaurant, and
        authorize
        Smartdine to charge the food, drink and other goods or services you order to the credit card (including any
        taxes
        and late payment fees, if applicable). You are responsible for the punctual payment of all costs and the
        provision
        of a valid credit card with which you will pay all costs to Smartdine at any time.
      </p>
      <p>
        4.6 Smartdine uses an external payment processing service (the ‘Payment Services Provider’) to link your credit
        card with the Platform and the Service. In addition to these Terms of Use, the processing of payments or credit,
        if
        applicable, in connection with your use of the Platform and the Service is subject to the terms and conditions
        and
        data protection guidelines of the Payment Services Provider and your credit card company. Smartdine is not
        responsible for any errors made by the Payment Services Provider. In connection with your use of the services,
        Smartdine will receive certain transaction details that it will use exclusively in line with its privacy policy.
      </p>

      <h4>5. LICENCE AND RESTRICTIONS</h4>
      <p>
        5.1 Provided that you comply with these Terms of Use in their entirety, Smartdine grants you a limited,
        non-exclusive, revocable and non-transferable license that cannot be sub-licensed: (i) to access the Service and
        use
        it on your device in connection with the use of the Service; and (ii) to access all content, information and
        related
        material available through the Platform and use it for private, non-commercial purposes. Smartdine and its
        licensors
        retain all rights not expressly granted herein.
      </p>
      <p>
        5.2 The following is not permitted: (i) To remove references to copyrights, trademarks or other intellectual
        property rights from any component of the Platform; (ii) to reproduce, modify, derive second-hand works from,
        sell,
        license, rent out, sell, resell, transfer, publicly disclose or display, transmit, stream, send or otherwise
        exploit
        the Platform without the express consent of Smartdine; (iii) to decompile, reverse engineer or disassemble the
        Platform beyond the limits of what is legally permissible; (iv) to create a link, frame or mirror a component of
        the
        Platform; (v) to develop or install programs or scripts in order to scrape, index, survey or otherwise mine data
        or
        to unduly limit or inhibit the functionality of aspects of the Platform; or (vi) to attempt to gain unauthorized
        access to or impede a component of the Platform and its related systems or networks.
      </p>
      <p>
        5.3 The Service and the Platform and all rights to these are and will remain the property of Smartdine and the
        licensors of Smartdine.
      </p>
      <p>
        5.4 Neither these Terms of Use nor your use of the Service will grant you any of the following rights: (i) to
        or in
        connection with the Service or the Platform, with the exception of the aforementioned limited license; or (ii)
        to
        use or reference the name, logos, brands or other distinguishing marks of Smartdine or the licensors of
        Smartdine.
      </p>
      <p>
        5.5 However, the Service and the Platform can be made accessible or used in connection with third- party
        services
        and/or content (including advertisements). You acknowledge that other terms of use and data protection
        provisions
        may apply in this regard. Smartdine cannot be held responsible or liable for any goods, services or content of
        third
        parties.
      </p>

      <h4>6. USER CONTENT</h4>
      <p>
        6.1 At its sole discretion, Smartdine may permit you to submit, upload, publish or otherwise render available
        to
        Smartdine, the Participating Restaurants and/or other users text, audio and/or image content and information
        through
        the Platform; i.e. comments and feedback on the service, food and drink or other menu items or services, the
        Service, support queries and the submission of contributions (‘User Content’). You will remain the owner of all
        User
        Content you submit or otherwise make available.
      </p>
      <p>
        6.2 However, you grant Smartdine a global, irrevocable, transferable, free license – sub-licensable and
        unrestricted in terms of content or time – to all User Content, in particular to use, duplicate, market, alter,
        publish, disclose, exhibit in public and otherwise use in all formats and on all sales channels, regardless of
        whether these currently exist and/or are known or whether they emerge or become known only in the future.
      </p>
      <p>
        6.3 You are responsible for ensuring that: (i) You are either the sole and exclusive owner of all User Content
        or
        hold all rights, licenses, permits and clearance required to grant Smartdine the aforementioned license to the
        User
        Content; and (ii) neither the User Content itself nor the act of sending, uploading, publishing or otherwise
        disclosing it, including use of the User Content by Smartdine, violates or ignores intellectual property rights
        or
        other rights of third parties, publication rights, personal rights or data privacy rights of third parties or
        could
        be held to represent a violation of applicable laws or regulations.
      </p>
      <p>
        6.4 You undertake not to place, send, upload, transfer, publish or make available any User Content that is
        offensive, slanderous, rude, violent, obscene, pornographic or otherwise objectionable or illegal, as judged by
        Smartdine at its own discretion, regardless of whether the User Content is protected by law. At its own
        discretion,
        Smartdine is entitled to check, monitor and remove User Content without notification. However, Smartdine is not
        obliged to check, monitor or remove User Content.
      </p>

      <h4>7. INDEMNIFICATION</h4>
      <p>
        7.1 You undertake to indemnify Smartdine, its subsidiaries, licensors and elements, managers, employees and
        contractors against all claims, costs, damage, losses and liability claims (including legal fees and expenses)
        resulting from or in connection with a violation of any provision of these Terms of Use, statutory provisions or
        third-party rights – including those of Participating Restaurants – by you, or from or in connection with your
        use
        of the Service and/or Platform.
      </p>

      <h4>8. EXCLUSION OF ASSURANCES AND GUARANTEES</h4>
      <p>
        8.1 All guarantees of Smartdine, in particular relating to the Service and Platform, are hereby excluded.
        Smartdine
        makes no assurances and issues no guarantees or warranties of any kind related to the Platform or the Service.
      </p>
      <p>
        8.2 Similarly, Smartdine makes no assurances and issues no guarantees or warranties of any kind related to the
        quality or suitability of the services of Participating Restaurants.
      </p>
      <p>8.3 The service is provided ‘as is’ and as available.</p>
      <p>
        8.4 In particular, Smartdine cannot guarantee that the Website, its content, the Service and/or the Platform
        are
        free from errors, defects, harmful programs or viruses, or that the Website and/or the Platform are correct, up
        to
        date or free from errors.
      </p>
      <p>
        8.5 Furthermore, Smartdine makes no assurances and issues no guarantee that the Service will not be disrupted
        or is
        otherwise free from errors, and issues no guarantee concerning the reliability, quality, suitability or
        availability
        of the Service, Platform or other services in connection with the Service and Platform. Temporary disruptions or
        errors may occur, and the Service or Platform might experience restrictions, disruptions, delays or other
        problems.
      </p>

      <h4>9. DISCLAIMER AND LIMITATIONS OF LIABILITY</h4>
      <p>
        9.1 Smartdine can be held liable for damage caused only through intent or gross negligence on the part of its
        elements.
      </p>
      <p>9.2 Smartdine rejects all other liability.</p>
      <p>
        9.3 In particular, Smartdine cannot be held liable for any damage resulting from the use of (or inability to
        use)
        the Website, Platform or Service, including due to harmful programs, viruses, errors or the incompleteness of
        the
        information, Website or Platform.
      </p>
      <p>
        9.4 Smartdine cannot be held liable for damage to third parties or third-party claims for damages, in
        particular
        for any damage resulting from or in connection with a contract between you and a Participating Restaurant. The
        quality of the food and drink provided through the use of the Platform or Service is the full responsibility of
        the
        Participating Restaurant that provides the service. Under no circumstances will Smartdine accept any liability
        for
        and/or in connection with the food and drink provided by the Participating Restaurant or any other actions or
        omissions on the part of the Participating Restaurant. Any complaints related to the services of the
        Participating
        Restaurant or the food or drink should therefore be addressed to the Participating Restaurant.
      </p>
      <p>
        9.5 Should you contact us regarding a service contract or dispute with a Participating Restaurant, we will
        refer
        you to it. Should a Participating Restaurant contact us regarding a service contract or dispute with you, we
        will
        refer it to you; however, we reserve the right to provide the Participating Restaurant with information about
        you
        and the service contract or dispute in question.
      </p>
      <p>
        9.6 These disclaimers and limitations of liability also apply to auxiliaries of Smartdine and their agents and
        representatives.
      </p>

      <h4>10. APPLICABLE LAW, PLACE OF JURISDICTION AND OTHE PROVISIONS</h4>

      <p>
        10.1 These Terms of Use are subject to Swiss law, excluding the regulations of private international law and
        the UN
        Convention on Contracts for the International Sale of Goods (CISG).
      </p>
      <p>
        10.2 The place of exclusive jurisdiction for all disputes arising from or in connection with these Terms of Use
        is
        Geneva, Switzerland.
      </p>
      <p>
        10.3 If any provision of these Terms of Use or the Contract should be null and void or ineffective, this shall
        not
        affect the effectiveness of the other provisions of the Terms of Use or Contract. Where legally permissible, the
        null and void or ineffective provision will be replaced by a provision that best approximates its original
        economic
        purpose.
      </p>
      <p>
        10.4 You may not transfer your rights and duties under these Terms of Use to a third party without the prior,
        express written consent of Smartdine.
      </p>
      <p>
        10.5 Smartdine may contact you regarding the Service or Platform by means of a general notification or an email
        or
        standard letter sent to the email address you provided at the check- out stage on the platform and held by
        Smartdine.
      </p>
    </div>
    <div class="tc-wrapper">
      <a class="tc-save-link" href="../../static/docs/termsconditions_smartdine.pdf" download>Save</a>
    </div>
  </div>
</template>

<script>
export default { name: 'TermsConditions' }
</script>

<style scoped>
.btn.btn-danger {
  float: right;
}
.tc-wrapper {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-areas: "a b c d";
}
.tc-save-link {
  grid-area: d;
  align-self: right;
  padding-bottom: .5em;
  color: #dc3545;
}
</style>



// WEBPACK FOOTER //
// src/components/TermsConditions.vue